import React from 'react';

import ModalView from '../modalView';

const NewSprintModal = props => (
  <ModalView
    title="Create new sprint"
    titleAction="Save"
    {...props}
  />
);

export default NewSprintModal;
